import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
  Stack,
  Divider,
  List,
  ListItem,
  ListItemText
} from '@mui/material';

const BRAND_ARCHITECTURE = [
  {
    brand: 'IQOS',
    sections: [
      {
        title: 'Core',
        items: ['TEREA - Tobacco', 'TEREA - Flavor/Menthol']
      },
      {
        title: 'HNS',
        items: ['LEVIA - Full Portfolio']
      },
      {
        title: 'Below-Base',
        items: ['DELIA - Full Portfolio']
      }
    ]
  },
  {
    brand: 'glo',
    sections: [
      {
        title: 'Core',
        items: [
          'NEO - Tobacco',
          'NEO - Flavor/Menthol',
        ]
      },
      {
        title: 'HNS',
        items: ['VEO - Full Portfolio']
      },
      {
        title: 'Combustible Brands',
        items: [
          'KENT',
          'DUNHILL',
          'LUCKY STRIKE'
        ]
      }
    ]
  },
  {
    brand: 'ploom',
    sections: [
      {
        title: 'Core',
        items: ['All Brands']
      },
      {
        title: 'HNS',
        items: ['All Brands']
      },
 
    ]
  }
];

const IQOS_PORTFOLIO = [
  {
    title: 'Iqos Iluma',
    tags: ['HNS'],
    bullets: [

    ],
    consumables: {
      label: 'HEETS',
      bullets: [

      ]
    }
  },

  {
    title: 'Originals Duo / Originals One',
    tags: ['HTS'],
    bullets: [

    ],
    consumables: {
      label: 'HEETS',
      bullets: [

      ]
    }
  },

];

const GLO_PORTFOLIO = [
  {
    title: 'Hyper Pro',
    tags: ['HTS'],
    bullets: [

    ]
  },
  {
    title: 'Hyper',
    tags: ['HTS'],
    bullets: [

    ]
  },
  {
    title: 'Hyper X2 Air',
    tags: ['HTS'],
    bullets: [

    ]
  },
];

const PLOOM_PORTFOLIO = [
  {
    title: 'X Advanced',
    tags: ['HTS'],
    bullets: [

    ]
  },
  {
    title: 'Ploom Aura',
    tags: ['HTS'],
    bullets: [

    ]
  },
  {
    title: 'Consumables Portfolio',
    tags: ['HTS'],
    bullets: ['EVO', 'CAMEL', 'WINSTON', 'SOBRANIE']
  }
];

const bulletListStyles = {
  '& .MuiListItem-root': { py: 0, px: 0 },
  '& .MuiListItemText-primary': { fontSize: '0.9rem', color: '#333' }
};

const ProductCategorisationView = () => {
  return (
    <Box sx={{ padding: '24px 32px 40px' }}>
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, marginBottom: 1 }}>
          Product Categorisation
        </Typography>
        <Typography variant="body1" sx={{ color: '#555', maxWidth: 900 }}>
          Overview of brands across IQOS, Glo, and Ploom.
        </Typography>
      </Box>

      <Typography variant="h5" sx={{ fontWeight: 700, marginBottom: 2 }}>
        Brand Overview
      </Typography>
      <Grid container spacing={2} sx={{ marginBottom: 4 }}>
        {BRAND_ARCHITECTURE.map((brand) => (
          <Grid item xs={12} md={4} key={brand.brand}>
            <Card elevation={0} sx={{ borderRadius: 2, border: '1px solid #e0e0e0' }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, marginBottom: 1 }}>
                  {brand.brand}
                </Typography>
                <Stack spacing={2}>
                  {brand.sections.map((section) => (
                    <Box key={section.title}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1a1a1a' }}>
                        {section.title}
                      </Typography>
                      <List dense sx={bulletListStyles}>
                        {section.items.map((item, index) => (
                          <ListItem key={`${section.title}-${index}`}>
                            <ListItemText primary={item} />
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  ))}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Typography variant="h5" sx={{ fontWeight: 700, marginBottom: 2 }}>
        Portfolio Detail
      </Typography>

      <Grid container spacing={2} sx={{ marginBottom: 3 }}>
        <Grid item xs={12} md={6}>
          <Card elevation={0} sx={{ borderRadius: 2, border: '1px solid #e0e0e0' }}>
            <CardContent>
              <Typography variant="h6" sx={{ fontWeight: 700, marginBottom: 1 }}>
                IQOS
              </Typography>
              {IQOS_PORTFOLIO.map((item, index) => (
                <Box key={item.title} sx={{ marginBottom: index === IQOS_PORTFOLIO.length - 1 ? 0 : 2 }}>
                  <Stack direction="row" spacing={1} sx={{ alignItems: 'center', marginBottom: 0.5 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      {item.title}
                    </Typography>
                    {item.tags.map((tag) => (
                      <Chip key={tag} size="small" label={tag} sx={{ fontSize: '0.7rem' }} />
                    ))}
                  </Stack>
                  <List dense sx={bulletListStyles}>
                    {item.bullets.map((bullet, bulletIndex) => (
                      <ListItem key={`${item.title}-${bulletIndex}`}>
                        <ListItemText primary={bullet} />
                      </ListItem>
                    ))}
                  </List>
                  {item.consumables && (
                    <Box sx={{ marginTop: 1 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        Consumables: {item.consumables.label}
                      </Typography>
                      <List dense sx={bulletListStyles}>
                        {item.consumables.bullets.map((bullet, bulletIndex) => (
                          <ListItem key={`${item.consumables.label}-${bulletIndex}`}>
                            <ListItemText primary={bullet} />
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  )}
                  {index < IQOS_PORTFOLIO.length - 1 && <Divider sx={{ marginTop: 2 }} />}
                </Box>
              ))}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            <Card elevation={0} sx={{ borderRadius: 2, border: '1px solid #e0e0e0' }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, marginBottom: 1 }}>
                  glo
                </Typography>
                {GLO_PORTFOLIO.map((item, index) => (
                  <Box key={item.title} sx={{ marginBottom: index === GLO_PORTFOLIO.length - 1 ? 0 : 2 }}>
                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center', marginBottom: 0.5 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {item.title}
                      </Typography>
                      {item.tags.map((tag) => (
                        <Chip key={tag} size="small" label={tag} sx={{ fontSize: '0.7rem' }} />
                      ))}
                    </Stack>
                    <List dense sx={bulletListStyles}>
                      {item.bullets.map((bullet, bulletIndex) => (
                        <ListItem key={`${item.title}-${bulletIndex}`}>
                          <ListItemText primary={bullet} />
                        </ListItem>
                      ))}
                    </List>
                    {index < GLO_PORTFOLIO.length - 1 && <Divider sx={{ marginTop: 2 }} />}
                  </Box>
                ))}
              </CardContent>
            </Card>

            <Card elevation={0} sx={{ borderRadius: 2, border: '1px solid #e0e0e0' }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, marginBottom: 1 }}>
                  ploom
                </Typography>
                {PLOOM_PORTFOLIO.map((item, index) => (
                  <Box key={item.title} sx={{ marginBottom: index === PLOOM_PORTFOLIO.length - 1 ? 0 : 2 }}>
                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center', marginBottom: 0.5 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        {item.title}
                      </Typography>
                      {item.tags.map((tag) => (
                        <Chip key={tag} size="small" label={tag} sx={{ fontSize: '0.7rem' }} />
                      ))}
                    </Stack>
                    <List dense sx={bulletListStyles}>
                      {item.bullets.map((bullet, bulletIndex) => (
                        <ListItem key={`${item.title}-${bulletIndex}`}>
                          <ListItemText primary={bullet} />
                        </ListItem>
                      ))}
                    </List>
                    {index < PLOOM_PORTFOLIO.length - 1 && <Divider sx={{ marginTop: 2 }} />}
                  </Box>
                ))}
              </CardContent>
            </Card>
          </Stack>
        </Grid>
      </Grid>

    </Box>
  );
};

export default ProductCategorisationView;
